import * as protocol from '../../../apis/observationalProtocol'
import { ListContainer } from '../../../utilties/linkedList'
import { createSelector } from 'reselect'
import history from '../../../utilties/history'
import { setErrorCode } from '../core'

const FETCH_SURVEY_REQUESTED = 'FETCH_SURVEY_REQUESTED'
const FETCH_SURVEY_SUCCESS = 'FETCH_SURVEY_SUCCESS'
const FETCH_SURVEY_FAILED = 'FETCH_SURVEY_FAILED'

export const fetchSurvey = (observationProtocolSurveyId, caseId, surveyId, languageId) => (dispatch) => {
	dispatch({ type: FETCH_SURVEY_REQUESTED, data: {} })

	protocol.getSurvey(observationProtocolSurveyId, caseId, surveyId, languageId).then((survey) => {
		if (survey && survey.isSuccessful) {
			let questionContainerList = []
			let hashList = []
			let containerList = []
			let revisionsList = []
			let patientCaseSurveyInstances = {}

			survey.answeredQuestions.map((answeredQuestions, index) => {
				let questionContainer = new Array(0)
				let hash = {}
				let container = new ListContainer()

				processSurveyQuestions(answeredQuestions.questions, container, questionContainer, hash)

				questionContainerList.push(questionContainer)
				hashList.push(hash)
				containerList.push(container)
				revisionsList.push(answeredQuestions.revisions)
				patientCaseSurveyInstances[`${index}`] = {
					patientCaseSurveyInstanceId: answeredQuestions.patientCaseSurveyInstanceId,
					bilateralAreaId: answeredQuestions.bilateralAreaId,
					patientCaseSurveyInstanceVersion: answeredQuestions.patientCaseSurveyInstanceVersion
				}
			})

			return dispatch({
				type: FETCH_SURVEY_SUCCESS,
				data: {
					survey: survey,
					list: containerList,
					flat: questionContainerList,
					nodes: hashList,
					patientCaseSurveyInstances: patientCaseSurveyInstances
				}
			})
		} else {
			if(survey && survey.errorCode)
			{
				dispatch(setErrorCode(survey.errorCode))
				history.push('/error');
			} else if(!survey || !survey.redirectTo) {
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: {
						message: 'app.protocol.fetchSurveyFailed',
						isSuccess: false
					}
				})	
			}			
		}
	})
}

const processSurveyQuestions = (surveyQuestions, container, questionContainer, hash) => {
	if (surveyQuestions) {
		surveyQuestions.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1)).map((r) => {
			container.getList().append(r)
		})
		container.getList().traverse((r) => {
			questionContainer.push(r.data.uniqueId)
			hash[r.data.uniqueId] = r
		})
	}
}

const FETCH_SURVEY_NAVIGATION_REQUESTED = 'FETCH_SURVEY_NAVIGATION_REQUESTED'
const FETCH_SURVEY_NAVIGATION_SUCCESS = 'FETCH_SURVEY_NAVIGATION_SUCCESS'
const FETCH_SURVEY_NAVIGATION_FAILED = 'FETCH_SURVEY_NAVIGATION_FAILED'

export const fetchSurveyNavigation = (observationProtocolSurveyId, caseId, surveyId, languageId) => (dispatch) => {
	dispatch({ type: FETCH_SURVEY_NAVIGATION_REQUESTED, data: {} })

	protocol.getSurveyNavigation(observationProtocolSurveyId, caseId, surveyId, languageId).then((surveyNavigation) => {
		if (surveyNavigation && surveyNavigation.isSuccessful) {
			return dispatch({
				type: FETCH_SURVEY_NAVIGATION_SUCCESS,
				data: {
					surveyNavigation: surveyNavigation
				}
			})
		} else if(!surveyNavigation || !surveyNavigation.redirectTo) {
			return dispatch({ type: FETCH_SURVEY_NAVIGATION_FAILED, data: {} })
		}
	})
}

export const fetchSurveyNavigationByCaseId = (caseId, languageId) => (dispatch) => {
	return dispatch(fetchSurveyNavigation(0, caseId, 0, languageId))
}

const FETCH_BILATERAL_AREAS_REQUESTED = 'FETCH_BILATERAL_AREAS_REQUESTED'
const FETCH_BILATERAL_AREAS_SUCCESS = 'FETCH_BILATERAL_AREAS_SUCCESS'
const FETCH_BILATERAL_AREAS_FAILED = 'FETCH_BILATERAL_AREAS_FAILED'

export const fetchBilateralAreas = (versionId) => (dispatch) => {
	dispatch({ type: FETCH_BILATERAL_AREAS_REQUESTED, data: {} })

	protocol.fetchBilateralAreas(versionId).then((data) => {
		if (data && data.isSuccessful) {
			return dispatch({ type: FETCH_BILATERAL_AREAS_SUCCESS, data: data })
		} else {
			return dispatch({ type: FETCH_BILATERAL_AREAS_FAILED, data: {} })
		}
	})
	return
}


const initial = {
	survey: null,
	surveyNavigation: null,
	originalSurvey: null,
	surveyQuestions: null,
	surveyQuestionIds: null,
	surveyQuestionHash: null,
	originalSurveyQuestions: null,
	originalSurveyQuestionIds: null,
	originalSurveyQuestionHash: null,
	surveyRefreshed: false,
	form: 'survey',
	bilateralAreas: null,
	patientCaseSurveyInstances: null
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case FETCH_SURVEY_SUCCESS:
			return {
				...state,
				survey: action.data.survey,
				originalSurvey: action.data.survey,
				surveyQuestions: action.data.list,
				surveyQuestionHash: action.data.nodes,
				surveyQuestionIds: action.data.flat,
				originalSurveyQuestions: action.data.list,
				originalSurveyQuestionHash: action.data.nodes,
				originalSurveyQuestionIds: action.data.flat,
				patientCaseSurveyInstances: action.data.patientCaseSurveyInstances,
				surveyRefreshed: true,
			}
		case FETCH_SURVEY_REQUESTED:
			return {
				...state,
				survey: null,
				originalSurvey: null,
				surveyQuestions: null,
				surveyQuestionHash: null,
				surveyQuestionIds: null,
				originalSurveyQuestions: null,
				originalSurveyQuestionHash: null,
				originalSurveyQuestionIds: null,
				patientCaseSurveyInstances: null,
			}
		case FETCH_SURVEY_NAVIGATION_SUCCESS:
			return {
				...state,
				surveyNavigation: action.data.surveyNavigation
			}
		case FETCH_SURVEY_NAVIGATION_REQUESTED:
			return {
				...state,
				surveyNavigation: null
			}

		case FETCH_BILATERAL_AREAS_FAILED:
		case FETCH_BILATERAL_AREAS_REQUESTED:
			return {
				...state,
				bilateralAreas: null
			}
		case FETCH_BILATERAL_AREAS_SUCCESS:
			return {
				...state,
				bilateralAreas: action.data
			}

		default:
			return { ...state }
	}
}

const mainSelector = (state) => state.protocol

export const surveySelector = createSelector(mainSelector, (state) => {
	return state.survey
})

export const formSelector = createSelector(mainSelector, (state) => {
	return state.form
})

export const surveyQuestionsSelector = createSelector(mainSelector, (state) => {
	return state.surveyQuestions && state.surveyQuestions.getList()
})

export const questionListSelector = createSelector(mainSelector, (state) => {
	if (state && state.surveyQuestions) return state.surveyQuestions
})

export const questionHashSelector = createSelector(mainSelector, (state) => {
	if (state && state.surveyQuestionHash) return state.surveyQuestionHash
})

export const questionIdSelector = createSelector(mainSelector, (state) => {
	if (state && state.surveyQuestionIds) return state.surveyQuestionIds
})

export const questionsSelector = createSelector(
	mainSelector,
	questionIdSelector,
	questionHashSelector,
	(state, idsContainers, hash) => {
		if (state && idsContainers && idsContainers.length > 0 && hash) {
			let questionContainers = []

			idsContainers
				.map((ids, index) => {
					let questions = []

					ids.map((r) => {
						if (hash[index].hasOwnProperty(r)) {
							let x = hash[index][r]
							questions.push(x)
						} else {
							console.info('No Property', questions)
						}
					})

					questionContainers.push(questions)
				})

			return questionContainers
		}
	}
)

export const surveyNavigationSelector = createSelector(mainSelector, (state) => {
	return state.surveyNavigation
})

export const bilateralAreasSelector = createSelector(mainSelector, (state) => {
	return state && state.bilateralAreas
})
